import { MaterialStorageType } from 'api';

export const formatStorageType = (storageType: MaterialStorageType) => {
  switch (storageType) {
    case MaterialStorageType.BL:
      return 'Baled';
    case MaterialStorageType.LB:
      return 'Loosely Baled';
    case MaterialStorageType.TB:
      return 'Tightly Baled';
    case MaterialStorageType.BG:
      return 'Bagged';
    case MaterialStorageType.LS:
      return 'Loose';
    case MaterialStorageType.BQ:
      return 'Briquettes';
    case MaterialStorageType.BISCUITS:
      return 'Biscuits';
    default:
      return '';
  }
};
